import produce from "immer"
import { CONFIDENCE_MEDIUM } from "const"
import { OkrKeyResultUpdate } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initOkrKeyResultUpdate: OkrKeyResultUpdate = {
    id: null,
    keyResultId: null,
    author: null,
    value: null,
    confidenceLevel: CONFIDENCE_MEDIUM,
    note: "",
    dateUpdate: null,
}

const initOkrKeyResultUpdateState: types.OkrKeyResultUpdateState = {
    updateList: {},
    updateEdit: initOkrKeyResultUpdate,

    reloadEdit: true,
}

const okrKeyResultUpdateReducer = produce((
    draft: types.OkrKeyResultUpdateState = initOkrKeyResultUpdateState,
    action: ActionTypes = null,
): types.OkrKeyResultUpdateState => {
    switch (action.type) {
        case types.OKR_KEY_RESULT_UPDATE_LIST:
            draft.updateList = {
                ...draft.updateList,
                ...action.updateList,
            }
            return draft

        case types.OKR_KEY_RESULT_UPDATE_EDIT:
            draft.updateEdit = action.update
            return draft

        case types.OKR_KEY_RESULT_UPDATE_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default okrKeyResultUpdateReducer
